import { IconType } from 'react-icons';
import { PiHeartLight, PiBoatLight, PiCookingPotLight } from 'react-icons/pi';

export interface Programme {
  /** Value submitted by the enrolment form — keep stable, it reaches the PHP endpoint. */
  id: string;
  /** Display name, including the n-in-1 label exactly as supplied. */
  title: string;
  /** Short name for compact contexts (hero list, form options). */
  shortTitle: string;
  icon: IconType;
  /** Learning period, excluding the assignment window. */
  duration: string;
  /** Notional hours. Not supplied for the Professional Chef programme. */
  hours?: string;
  summary: string;
  modules: string[];
}

/** Every programme gets the same post-learning assignment window. */
export const ASSIGNMENT_WINDOW = '5 additional days for assignment completion and submission';

export const programmes: Programme[] = [
  {
    id: 'Caregiver Course (4n1)',
    title: 'Caregiver Course (4n1)',
    shortTitle: 'Caregiver',
    icon: PiHeartLight,
    duration: '2 weeks',
    hours: '80 hours',
    summary:
      'Foundation training across dementia care, safeguarding, early childhood and night nursing — the broadest of our three programmes, and the only one with a practical placement.',
    modules: [
      'Dementia Module',
      'Safeguarding Module',
      'Early Childhood Development',
      'Child Minding',
      'AU Pair',
      'Night Nursing',
      'CPR First Aid Level 1',
    ],
  },
  {
    id: 'Cruise Ship Course (3n1)',
    title: 'Cruise Ship Course (3n1)',
    shortTitle: 'Cruise Ship',
    icon: PiBoatLight,
    duration: '2 weeks',
    hours: '80 hours',
    summary:
      'Hospitality training built for cruise ship and hotel environments, covering housekeeping, service and management fundamentals.',
    modules: ['Housekeeping', 'Serving & Hospitality', 'Hotel Management'],
  },
  {
    id: 'Professional Chef Programme (3n1)',
    title: 'Professional Chef Programme (3n1)',
    shortTitle: 'Professional Chef',
    icon: PiCookingPotLight,
    // The supplied brief gives no notional hours for this programme, only the
    // three-week learning period — so `hours` is intentionally omitted.
    duration: '3 weeks',
    summary:
      'Kitchen-focused training from professional cookery and food safety through to menu planning, kitchen management and career development.',
    modules: [
      'Professional Cookery',
      'Food Safety & Hygiene',
      'Baking & Pantry',
      'Menu Planning & Nutrition',
      'Kitchen Management',
      'Hospitality & Food Serving',
      'Professional Chef Skills & Career Development',
    ],
  },
];

/** Option values for the enrolment form's course select. */
export const programmeOptions = programmes.map((p) => p.id);
